import React, {  } from 'react';


import Collection from '../../../common/Collection'

import { GET, errorCatch, POST, deleteInArray, updateInArray } from 'fennec-ui'
import NovieUslugiNaMeropriyatii from '../NovieUslugiNaMeropriyatii';
import IzmenitUslugiNaMeropriyatii from '../IzmenitUslugiNaMeropriyatii';
import Icofont from 'react-icofont';



export default function UslugiNaMeropriyatii(props) {
    const { auth, object, sourceKey, soruceID, orgID, queryFilterContext } = props;
    // const [data, setData] = useState([]);
    // useEffect(() => {
    //     if (object) {
    //         GET(auth, "/api/usluginameropriyatii/bymeropriyatie/" + object.ID,
    //             ({data}) => {
    //                 setData(data);
    //             },
    //             (err)=>errorCatch(err));
    //     }
    // }, [object]);
    // const dataOptions = data.map((i) => <Option key={i.ID} value={i.ID}>{i.promokod}</Option>);
    return (
        <>
            <Collection
                auth={auth}
                noPrint={true}
                noPagination={true}
                size="small"
                // data={data}
                source={"/api/usluginameropriyatii/bymeropriyatie/" + object.ID}
                // ordering={{
                //     field : "sort",
                //     action: {
                //         method: "POST",
                //         path: "/api/usluginameropriyatii/sort",
                //         mutation: "upgrade",
                //     }
                // }}
                // source={"/api/usluginameropriyatii/bymeropriyatie/" + object.ID}

                // filters={() => [
                //     {
                //         name: 'Активная',
                //         value: item => !item.komissiyaPartneram.notActive, //(item.notActive) ? "Да" : "Нет",
                //         field: "active",
                //         type: "bool",
                //         filter: true,
                //         sort: true
                //     },
                //     {
                //         name: 'Неактивная',
                //         value: item => item.komissiyaPartneram.notActive, //(item.notActive) ? "Да" : "Нет",
                //         field: "notActive",
                //         type: "bool",
                //         filter: true
                //     }
                // ]}
                columns={() => [
                    {
                        title: 'Порядок сортировки',
                        render: (text, record) => {
                            return (record.sort);
                        }
                    },
                    {
                        title: 'Название услуги',
                        render: (text, record) => {
                            return (record.nazvanie);
                        }
                    },
                    {
                        title: 'Вид услуги',
                        render: (text, record) => {
                            return (record.vidUslugi.opisanie);
                        }
                    },
                    {
                        title: 'Количество позиций',
                        render: (text, record) => {
                            return (record.uslugiKlientuUslugaNaMeropriyatii&&record.uslugiKlientuUslugaNaMeropriyatii.length? 
                                <div>{record.uslugiKlientuUslugaNaMeropriyatii.length}</div>:
                                <div>0 <Icofont icon="exclamation-tringle" style={{color: "red"}} /></div>)
                        }
                    },
                    {
                        title: 'Количество тарифов',
                        render: (text, record) => {
                            return (record.tarifiUslugaNaMeropriyatii?record.tarifiUslugaNaMeropriyatii.length:"");
                        }
                    },
                    {
                        title: <div style={{width:"100%", textAlign: "end"}}>{'Среднее арифметическое цены услуги'}, руб.</div>,
                        render: (text, record) => {
                            let sumWithInitial = 0;
                            if(record.tarifiUslugaNaMeropriyatii && record.tarifiUslugaNaMeropriyatii.length) {
                                window.w = record.tarifiUslugaNaMeropriyatii
                                sumWithInitial = record.tarifiUslugaNaMeropriyatii.reduce((prev, curr) => prev + curr.summa, 0); 
                                sumWithInitial = sumWithInitial/record.tarifiUslugaNaMeropriyatii.length;
                            }
                            return <div style={{width:"100%", textAlign: "end"}}>{Number(sumWithInitial.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.</div>
                        }
                    }
                ]}
                collectionActions={() => [
                    {
                        action: (values, unlock, close, { collection, setCollection }) => {
                            POST(auth, '/api/usluginameropriyatii/new', { ...values, meropriyatieID: object.ID },
                                (res) => {
                                    setCollection(updateInArray(collection, res.data));
                                    close();
                                }, (err)=>errorCatch(err,unlock)
                            );
                        },                       
                        triggerOptions: {
                            type: "primary"
                        },
                        form: NovieUslugiNaMeropriyatii,
                        title: "Новая услуга",
                        modal: {
                            width: "60%",
                            minWidth: "600px",
                            title: "Новая услуга на мероприятии",
                        }
                    },
                    {
                        action: (values, unlock, close, { collection, setCollection }) => {
                            GET(auth, "/api/usluginameropriyatii/bymeropriyatie/" + object.ID, 
                                ({data}) => {
                                    setCollection(data);
                                }, errorCatch
                            );
                        },                       
                        title: "Обновить",
                    }
                ]}
                modelActions={(item) => [
                    {
                        title: "Изменить",
                        modal: {
                            width: "50%",
                            minWidth: "500px",
                            title: "Изменить услугу на мероприятии",
                        },
                        action: (values, unlock, close, { collection, setCollection }) => {
                            POST(auth, '/api/usluginameropriyatii/update', { ...values, ID: item.ID, meropriyatieID: object.ID },
                                (res) => {
                                    setCollection(updateInArray(collection, res.data));
                                    close();
                                }, (err)=>errorCatch(err,unlock)
                            );
                        },                            
                        form: IzmenitUslugiNaMeropriyatii,
                        sourceKey: sourceKey,
                        soruceID: soruceID,
                        orgID: orgID,
                        queryFilterContext: queryFilterContext,
                    },
                    {
                        title: "Удалить",
                        action: (values, unlock, close, { collection, setCollection }) => {
                            POST(auth, '/api/usluginameropriyatii/delete', { ...item },
                                () => setCollection(deleteInArray(collection, item)), errorCatch
                            );
                        },
                    }
                ]}
            />
        </>
    );
}
